import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	notificationProjectSettingsEmptyProjectsBannerTitle: {
		defaultMessage: 'Choose a project to get started',
		id: 'personal-settings-notifications-config-table.project-notifications-config.empty-state.notification-project-settings-empty-projects-banner-title',
		description:
			'The title for the empty state when no projects are added in the project notifications',
	},
	notificationProjectSettingsEmptyProjectsBannerBodyText: {
		defaultMessage:
			"Don't want to apply default notifications to all your projects? Customize their notification settings.",
		id: 'personal-settings-notifications-config-table.project-notifications-config.empty-state.notification-project-settings-empty-projects-banner-body-text',
		description:
			'The body for the empty state when no projects are added in the project notifications',
	},
});
